// © Microsoft Corporation. All rights reserved.

/**
 * Platform type
 */
export enum PlatformType {
    App = "app",
    Web = "web"
}